import { render, staticRenderFns } from "./CatalogCategoryCreate.vue?vue&type=template&id=4476130e&"
import script from "./CatalogCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./CatalogCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports